import { createReducer } from 'src/utils/reducer'
import * as actions from 'src/constants/actionTypes'

import { LOCATION_CHANGE } from 'connected-react-router'

export const TOGGLE_CONTROL = 'TOGGLE_CONTROL'
export const SET_SINGLE_OPEN_ACTION = 'SET_SINGLE_OPEN_ACTION'
export const OPEN_CONTACT_SEARCH = 'OPEN_CONTACT_SEARCH'
export const CLOSE_CONTACT_SEARCH = 'CLOSE_CONTACT_SEARCH'

export const initialControlsState = {
    singleOpenAction: null,
    isEditingParents: false,
    isMovingAction: false,
    isInsertingActionAsSibling: false,
    isInsertingActionAsChild: false,
    isChangingOwner: false,
    isChangingOwnerUserOnly: false,
    isAddingDevices: false,
    isManipulatingSolution: false,
    isConfirmingStatusChangePropagate: false,
    isEditingBaseFields: false,
    isDeletingAction: false,
    selectedWindow: 'actions-list',
    isShowingCIs: false,
    isRefreshingCmdb: false,
    isDrawerOpen: false,
    activeActionDetailsDrawerTab: 'details',
}

export const toggleControl = (controlName, params) => ({
    type: TOGGLE_CONTROL,
    name: controlName,
    params,
})

export const singleEditAction = (actionUid) => ({
    type: SET_SINGLE_OPEN_ACTION,
    actionUid,
})

export const openContactSearch = (userOnly) => ({
    type: OPEN_CONTACT_SEARCH,
    userOnly,
})

export const closeContactSearch = () => ({
    type: CLOSE_CONTACT_SEARCH,
})

export const selectWindow = (window) => ({
    type: actions.SELECT_RUNBOOK_WINDOW,
    window,
})

export const setActionId = (id) => {
    return {
        type: actions.SET_SELECTED_ACTION_ID,
        id,
    }
}

export default createReducer(initialControlsState, {
    [TOGGLE_CONTROL]: (state, action) => {
        return {
            ...state,
            [action.name]: !state[action.name],
            ...(action.params ? action.params : {}),
        }
    },
    [SET_SINGLE_OPEN_ACTION]: (state, action) => {
        return { ...state, singleOpenAction: action.actionUid }
    },
    [OPEN_CONTACT_SEARCH]: (state, action) => {
        return {
            ...state,
            isChangingOwner: true,
            isChangingOwnerUserOnly: action.userOnly,
        }
    },
    [CLOSE_CONTACT_SEARCH]: (state, action) => {
        return {
            ...state,
            isChangingOwner: false,
            singleOpenAction: null,
            isChangingOwnerUserOnly: false,
        }
    },
    [actions.SAVE_SUPPLIER_SUCCESS]: (state, action) => {
        return {
            ...state,
            isChangingOwner: false,
            singleOpenAction: null,
            isChangingOwnerUserOnly: false,
        }
    },
    [actions.DELETE_ACTION]: (state, action) => {
        return {
            ...state,
            singleOpenAction:
                action.id === state.singleOpenAction
                    ? null
                    : state.singleOpenAction,
        }
    },
    [LOCATION_CHANGE]: (state) => {
        // if (action.payload.location.pathname === NEW_PATH) {
        return {
            ...state,
            singleOpenAction: null,
        }
        // } else {
        //     return {
        //         ...state,
        //     }
        // }
    },
    [actions.SELECT_RUNBOOK_WINDOW]: (state, action) => ({
        ...state,
        selectedWindow: action.window,
    }),
    [actions.END_RUNBOOK_SESSION]: (state, action) => ({
        ...state,
        selectedWindow: 'actions-list',
    }),
})
